
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificates/validation",
      function () {
        return require("private-next-pages/certificates/validation/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificates/validation"])
      });
    }
  